import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "direction", "gap", "className"];
import cx from 'classnames';
import React, { forwardRef } from 'react';
import { Box } from '../box';
import theme from './theme.css';
var Flex = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 0 : _ref$gap,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classNames = cx(_defineProperty({}, theme["gap-".concat(gap)], gap > 0), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    boxSizing: "border-box",
    flexDirection: direction,
    className: classNames,
    ref: ref
  }, rest), children);
});
Flex.displayName = 'Flex';
export default Flex;